<app-dialog [dialogWithInput]="dialog">
    <app-sale-save-product-form type="ADVANCED"
                                [productType]="productType"
                                [parentFormGroup]="formGroup"></app-sale-save-product-form>
    <app-button dialog-actions label="Ajouter" [disabled]="!formGroup.valid" (clickEvent)="add()" fill="solid" [loading]="service.loading$ | async"></app-button>
</app-dialog>
